import { render, staticRenderFns } from "./templateContentButtonCtaPhone.vue?vue&type=template&id=2620ee57&"
import script from "./templateContentButtonCtaPhone.vue?vue&type=script&lang=ts&"
export * from "./templateContentButtonCtaPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports